/* ====================================================================
 *  imageUrl — мапінг посилань на картинки товарів у наш проксі.
 *
 *  Живе в utils/, бо джерел уже двоє: обкладинки карток каталогу
 *  (`composables/catalog/useCardImage.ts`, п.9в) і галерея сторінки
 *  товару (`composables/product/galleryImages.ts`, п.9г). Функція чиста
 *  й без залежностей — тому й покрита тестом, чого в попередньому
 *  домі в неї не було.
 * ==================================================================== */

export function mapFirebaseUrlToProxy(rawUrl: unknown): string {
  if (!rawUrl) return "";
  // Голий Storage object path (denorm-поля) проксюємо напряму:
  // "products/<pid>/<file>.webp" -> "/api/img/products/<pid>/<file>.webp"
  if (typeof rawUrl === "string" && rawUrl.startsWith("products/")) {
    return `/api/img/${rawUrl}`;
  }
  try {
    const u = new URL(String(rawUrl));

    // працюємо тільки з Firebase Storage
    if (!u.hostname.includes("firebasestorage.googleapis.com")) {
      return String(rawUrl);
    }

    // частина після /o/ — закодований шлях типу "products%2F...%2Ffile.jpg"
    const parts = u.pathname.split("/o/");
    if (parts.length < 2) return String(rawUrl);

    const objectPath = decodeURIComponent(parts[1]);

    // підстраховка: тільки наші файли товарів
    if (!objectPath.startsWith("products/")) return String(rawUrl);

    return `/api/img/${objectPath}`;
  } catch {
    return String(rawUrl);
  }
}
